import React from 'react'
import { Card, CardContent, Typography } from '@material-ui/core';
import './InfoBox.css'

function InfoBox({ color, title, cases, active, total, ...props }) {

    const isDataAvaible = total !== 'Data unavaible' ? true : false

    return (
        <Card
        onClick={props.onClick}
        className={'infoBox'}
        style={active ? {borderTop:`10px solid ${color}`} : null}
        >
            <CardContent>
                <Typography className="infoBox__title" color="textSecondary">
                    {title}
                </Typography>
                <h2 style={{color:`${color}`}} className="infoBox__cases">
                    {cases}
                </h2>
                <Typography className="infoBox__total" color="textSecondary">
                    {total} {isDataAvaible ? 'Total' : ''}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default InfoBox;
